import CanvasWrapper from './CanvasWrapper';

export default class HeadlessCanvasWrapper extends CanvasWrapper {
	public initContext(width:number, height:number):void {
		this._context = require('gl')(width, height, { premultipliedAlpha: false });
	}

	get canvas() {
		throw new Error("Trying to retrieve canvas on headless gl.");
	}

	get content(): TexImageSource {
		let data:any = new Uint8Array(this.width * this.height * 4);
		let gl = this._context as WebGLRenderingContext;
		gl.readPixels(0, 0, this.width, this.height, gl.RGBA, gl.UNSIGNED_BYTE, data);

		return {
			width: this.width,
			height: this.height,
			data: data
		}
	}

	public toPPM = () => {
		let content = this.content as ImageData;
		let out = 'P3\n# gl.ppm\n' + this.width + " " + this.height + '\n255\n';
		for(var i=0; i<content.data.length; i++) out += (i-3)%4 ? content.data[i] + ' ':'';
		return out;
	}

	public resize = (width: number, height: number) => {
		let ext = this.context.getExtension('STACKGL_resize_drawingbuffer');
		ext.resize(width, height);
	}

	public delete = () => {
		if(this._context) {
			let ext = this._context.getExtension('STACKGL_destroy_context');
			ext.destroy();
		}
		delete this._context;
	}
}